// extracted by mini-css-extract-plugin
export default {"heading":"Subheading_heading__slD9z"};